import { denormalize } from 'normalizr';

import { VariableInfo } from '../../../lib/PlannerDTOs';
import { variable as variableSchema } from '../../../store/schema';
import { State } from '../../../store/state';
import {
  entitiesSelector,
  variableEntitiesSelector,
} from '../../../store/state/entities/selectors';
import { alphabeticalSort } from '../../../utils/string';
import {
  CollectionState,
  pageSelector,
  totalSelector,
} from '../shared/collection';
import { FetchVariableParams } from './common';
import { parseObjectToParams } from '@/utils/url';

export const variablesViewSelector = (state: State) => state.variables!.view;

// DEPRECATE
export const variablesSelector = (state: State): VariableInfo[] => {
  const entities = entitiesSelector(state);
  const variablesState = variablesViewSelector(state);
  const variables = denormalize(
    variablesState.items,
    [variableSchema],
    entities,
  );
  return variables;
};

export const variableSelector = (
  state: State,
  variableName: string,
): VariableInfo | null => {
  const variableEntities = variableEntitiesSelector(state);
  return variableEntities ? variableEntities[variableName] : null;
};

const variablePageStateSelector = (
  state: State,
  params: FetchVariableParams,
  page: number,
): CollectionState => {
  const query = parseObjectToParams(params, {
    sort: alphabeticalSort,
  });
  const variablesViewState = variablesViewSelector(state);
  const pageState = pageSelector(variablesViewState, query, page);

  return pageState;
};

export const variablePageSelector = (
  state: State,
  params: FetchVariableParams,
  page: number,
): VariableInfo[] => {
  const pageState = variablePageStateSelector(state, params, page);
  if (pageState) {
    const entities = entitiesSelector(state);
    const variables = denormalize(pageState.items, [variableSchema], entities);
    return variables;
  }
  return [];
};

export const variablePageFetchingStatusSelector = (
  state: State,
  params: FetchVariableParams,
  page: number,
): boolean => {
  const pageState = variablePageStateSelector(state, params, page);
  if (pageState) {
    return pageState.isFetching;
  }
  return false;
};

export const totalVariableCountSelector = (
  state: State,
  params: FetchVariableParams,
): number => {
  const query = parseObjectToParams(params, {
    sort: alphabeticalSort,
  });
  const variablesViewState = variablesViewSelector(state);
  const total = totalSelector(variablesViewState, query);
  return total;
};
